import { Button } from '@kanda-libs/ks-design-library';

import { useExpandingButtonContext } from 'components/ExpandingButton/context';

import BookACall from '../BookACall';

const MainContent: React.FunctionComponent = function () {
  const { onClick } = useExpandingButtonContext();

  return (
    <div className="flex flex-col gap-y-3 border-t border-neutral-300 px-3 pb-4 pt-2 bg-neutral-000">
      <Button.Icon
        icon="close"
        id="mobile-help-close"
        className="ml-auto"
        size="32-20"
        onClick={onClick}
      />
      <BookACall />
    </div>
  );
};

export default MainContent;
